module.exports = __webpack_public_path__ + "img/infograph_3.198b3074.png";